import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL2 || process.env.REACT_APP_BACKEND_URL || 'https://api.soalmhs.id/api';

// Debug logging - Force show in production
console.log('=== AXIOS DEBUG ===');
console.log('REACT_APP_BACKEND_URL2:', process.env.REACT_APP_BACKEND_URL2);
console.log('REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
console.log('Final baseURL:', baseURL);
console.log('==================');

// Force alert for production debugging
if (typeof window !== 'undefined') {
  window.AXIOS_DEBUG = {
    URL2: process.env.REACT_APP_BACKEND_URL2,
    URL: process.env.REACT_APP_BACKEND_URL,
    baseURL: baseURL
  };
  // Uncomment next line to see alert in production
  // alert('BaseURL: ' + baseURL);
}

const axiosInstance = axios.create({
  baseURL: baseURL,
});

export default axiosInstance;
